import "./styles.css";

type Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    dir?: "ltr" | "rtl";
};

export default function TextInput({ value, onChange, placeholder, disabled, readOnly, dir }: Props) {
    return (
        <input
            type="text"
            className="text-input"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            dir={dir}
        />
    );
}
